module.exports = __webpack_public_path__ + "assets/img/3027.73dbee25.svg";